export const Routes = {
  dashboard: '/',
  login: '/login',
  logout: '/logout',
  register: '/register',
  changePassword: '/change-password',
  resetPassword: '/reset-password',
  adminMyShops: '/my-shops',
  profile: '/profile',
  verifyCoupons: '/coupons/verify',
  settings: '/settings',
  storeSettings: '/vendor/settings',
  storeKeepers: '/vendor/store_keepers',
  profileUpdate: '/profile-update',
  checkout: '/orders/checkout',
  pendingcart:'/pending-cart',
  user: {
    ...routesFactory('/users'),
  },
  customer: {
    ...routesFactory('/customers'),
  },
  groups: {
    ...routesFactory('/groups'),
  },
  category: {
    ...routesFactory('/categories'),
  },
  attribute: {
    ...routesFactory('/attributes'),
  },
  attributeValue: {
    ...routesFactory('/attribute-values'),
  },
  tag: {
    ...routesFactory('/tags'),
  },
  reviews: {
    ...routesFactory('/reviews'),
  },
  abuseReviews: {
    ...routesFactory('/abusive_reports'),
  },
  abuseReviewsReport: {
    ...routesFactory('/abusive_reports/reject'),
  },
  author: {
    ...routesFactory('/authors'),
  },
  coupon: {
    ...routesFactory('/coupons'),
  },
  manufacturer: {
    ...routesFactory('/manufacturers'),
  },
  order: {
    ...routesFactory('/orders'),
  },
  orderStatus: {
    ...routesFactory('/order-status'),
  },
  orderCreate: {
    ...routesFactory('/orders/create'),
  },
  product: {
    ...routesFactory('/products'),
  },
  shop: {
    ...routesFactory('/shops'),
  },
  tax: {
    ...routesFactory('/taxes'),
  },
  shipping: {
    ...routesFactory('/shippings'),
  },
  withdraw: {
    ...routesFactory('/withdraws'),
  },
  staff: {
    ...routesFactory('/staffs'),
  },
  refund: {
    ...routesFactory('/refunds'),
  },
  question: {
    ...routesFactory('/questions'),
  },
  dealers: {
    ...routesFactory('/dealers'),
  }, 
  amcpackageprices: {
    ...routesFactory('/amcpackageprices'),
  }, 
  amcpackages: {
    ...routesFactory('/amcpackages'),
  },
  servicetickets: {
    ...routesFactory('/servicetickets'),
  },
   brands: {
    ...routesFactory('/brands'),
  },
  gstsettings: {
    ...routesFactory('/gst-settings'),
  },
  helpenquires:{
    ...routesFactory('/helpenquires'),
  },
  homeslider:{
     ...routesFactory('/homeslider'),
   },
   dealersubscriptions:{
    ...routesFactory('/dealer-subscriptions'),
   },
   staticpages:{
    ...routesFactory('/staticpages'),
   },
    testimonials:{
    ...routesFactory('/testimonials'),
   },
   jobresumes:{
    ...routesFactory('/jobresumes'),
   },
   upcomingproducts:{
     ...routesFactory('/upcomingproducts'),
   },
   productaddedbydealer:{
     ...routesFactory('/product-added-by-dealer'),
   },
   productaddedbyhospital:{
     ...routesFactory('/product-added-by-hospital'),
   },
   settings:{
    ...routesFactory('/setting'),
   },
   freeconsultation:{
    ...routesFactory('/free-consultation'),
   },
   partsrepair:{
    ...routesFactory('/partsrepair'),
   },
   newslettersubscribers:{
     ...routesFactory('/newslettersubscribers'),
   },
   hospitals:{
     ...routesFactory('/hospitals'),
   },
   dynamiclinks:{
     ...routesFactory('/dynamiclinks'),
   },
   inventory:{
     ...routesFactory('/inventory'),
   },
};

function routesFactory(endpoint: string) {
  return {
    list: `${endpoint}`,
    create: `${endpoint}/create`,
    editWithoutLang: (slug: string, shop?: string) => {
      return shop
        ? `/${shop}${endpoint}/${slug}/edit`
        : `${endpoint}/${slug}/edit`;
    },
    edit: (slug: string, language: string, shop?: string) => {
      return shop
        ? `/${language}/${shop}${endpoint}/${slug}/edit`
        : `${language}${endpoint}/${slug}/edit`;
    },
    translate: (slug: string, language: string, shop?: string) => {
      return shop
        ? `/${language}/${shop}${endpoint}/${slug}/translate`
        : `${language}${endpoint}/${slug}/translate`;
    },
    details: (slug: string) => `${endpoint}/${slug}`,
  };
}
